import { Reducer } from 'react';

import { Actions } from './constants';
import { ActionsType, State } from './types';

const initialState: State = {
  list: {},
  isLoading: false,
  error: undefined,
};

const draftsReducer: Reducer<State, ActionsType> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_DRAFTS_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.GET_DRAFTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
      };
    case Actions.GET_DRAFTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message,
        list: {},
      };
    case Actions.CONFIRM_DRAFT_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.CONFIRM_DRAFT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case Actions.CONFIRM_DRAFT_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message,
      };

    default:
      return state;
  }
};

export default draftsReducer;
